// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* JobDescription.css */

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Roboto", sans-serif;
}

.job-description-container {
  max-width: 900px;
  margin: 40px auto;
  padding: 20px;
}

.job-description-card {
  background: #ffffff;
  padding: 40px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.job-title {
  font-size: 2.2rem;
  color: #1a1a1a;
  font-weight: 700;
  margin-bottom: 10px;
}

.company-name {
  font-size: 1.5rem;
  color: #2c5282;
  font-weight: 500;
  margin-bottom: 20px;
}

.job-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 25px;
  margin-bottom: 30px;
  padding-bottom: 20px;
  border-bottom: 1px solid #e2e8f0;
}

.meta-item {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #4a5568;
  font-size: 1rem;
}

.meta-icon {
  color: #2c5282;
}

.job-section {
  margin-bottom: 30px;
}

.job-section h3 {
  font-size: 1.4rem;
  color: #1a1a1a;
  font-weight: 500;
  margin-bottom: 15px;
  border-bottom: 2px solid #2c5282;
  padding-bottom: 5px;
}

.job-section h4 {
  font-size: 1.2rem;
  color: #2d3748;
  font-weight: 500;
  margin: 20px 0 10px;
}

.job-section p {
  color: #4a5568;
  line-height: 1.6;
  font-size: 1rem;
}

.job-list {
  list-style-type: disc;
  margin-left: 20px;
  color: #4a5568;
  line-height: 1.8;
}

.job-list li {
  margin-bottom: 8px;
}

.contact-info {
  margin-top: 15px;
  font-weight: 500;
  color: #2c5282;
}

.hashtags {
  margin: 20px 0;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.hashtag {
  color: #2c5282;
  font-size: 0.9rem;
}

.apply-button {
  background: #2c5282;
  color: white;
  padding: 12px 24px;
  border: none;
  border-radius: 4px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: background 0.3s ease;
}

.apply-button:hover {
  background: #2b6cb0;
}

.button-icon {
  font-size: 0.9rem;
}`, "",{"version":3,"sources":["webpack://./src/components/JobDescription.css"],"names":[],"mappings":"AAAA,uBAAuB;;AAGvB;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;EACtB,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":["/* JobDescription.css */\n@import url(\"https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700&display=swap\");\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n  font-family: \"Roboto\", sans-serif;\n}\n\n.job-description-container {\n  max-width: 900px;\n  margin: 40px auto;\n  padding: 20px;\n}\n\n.job-description-card {\n  background: #ffffff;\n  padding: 40px;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.job-title {\n  font-size: 2.2rem;\n  color: #1a1a1a;\n  font-weight: 700;\n  margin-bottom: 10px;\n}\n\n.company-name {\n  font-size: 1.5rem;\n  color: #2c5282;\n  font-weight: 500;\n  margin-bottom: 20px;\n}\n\n.job-meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 25px;\n  margin-bottom: 30px;\n  padding-bottom: 20px;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.meta-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: #4a5568;\n  font-size: 1rem;\n}\n\n.meta-icon {\n  color: #2c5282;\n}\n\n.job-section {\n  margin-bottom: 30px;\n}\n\n.job-section h3 {\n  font-size: 1.4rem;\n  color: #1a1a1a;\n  font-weight: 500;\n  margin-bottom: 15px;\n  border-bottom: 2px solid #2c5282;\n  padding-bottom: 5px;\n}\n\n.job-section h4 {\n  font-size: 1.2rem;\n  color: #2d3748;\n  font-weight: 500;\n  margin: 20px 0 10px;\n}\n\n.job-section p {\n  color: #4a5568;\n  line-height: 1.6;\n  font-size: 1rem;\n}\n\n.job-list {\n  list-style-type: disc;\n  margin-left: 20px;\n  color: #4a5568;\n  line-height: 1.8;\n}\n\n.job-list li {\n  margin-bottom: 8px;\n}\n\n.contact-info {\n  margin-top: 15px;\n  font-weight: 500;\n  color: #2c5282;\n}\n\n.hashtags {\n  margin: 20px 0;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n.hashtag {\n  color: #2c5282;\n  font-size: 0.9rem;\n}\n\n.apply-button {\n  background: #2c5282;\n  color: white;\n  padding: 12px 24px;\n  border: none;\n  border-radius: 4px;\n  font-size: 1rem;\n  font-weight: 500;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  transition: background 0.3s ease;\n}\n\n.apply-button:hover {\n  background: #2b6cb0;\n}\n\n.button-icon {\n  font-size: 0.9rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
